// import env from './env'
import { resetTracking, setupTracking, addPrefixToObjectKeys } from './helpers'

export interface AppHeap {
  resetTracking: any;
  setupTracking: any;
  addPrefixToObjectKeys: any;
}

const heap: AppHeap = {
  resetTracking,
  setupTracking,
  addPrefixToObjectKeys,
};

export default heap

